import _ from "lodash";
import { connect } from "react-redux";
import CancelOrderItemsWindow from "../components/_CancelOrderItemsWindow";
import * as actions from "../../../_actions/order";
import * as miscActions from "../../../_actions/misc";

const mapStateToProps = ({ OrderCancel, Misc }) => ({
    loading: OrderCancel.fetching.loading,
    err: OrderCancel.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store,
    cancelReasons: OrderCancel.Reasons.data || [],
    cancelReasonsLoading: OrderCancel.Reasons.fetch.loading,
    cancelReasonsLoadingError: OrderCancel.Reasons.fetch.err,
    cancelOrderCalculateData: OrderCancel.Calculate.data,
    cancelOrderCalculating: OrderCancel.Calculate.fetch.loading,
    cancelOrderCalculatingError: OrderCancel.Calculate.fetch.err
});

const mapDispatchToProps = dispatch => ({
    cancelOrder: (orderId, cancelOrderData) => {
        dispatch(actions.cancelOrder(orderId, cancelOrderData));
    },
    getOrder: id => {
        dispatch(actions.get(id));
    },
    getCancelReasons: () => {
        dispatch(miscActions.getCancelReasons());
    },
    cancelOrderCalculate: (function () {
        let _id;
        let _cancelOrderCalculateData;

        let _cancelOrderCalculate = _.debounce(() => {
            dispatch(actions.cancelOrderCalculate(_id, _cancelOrderCalculateData));
        }, 500);

        return (id, cancelOrderCalculateData) => {
            _id = id;
            _cancelOrderCalculateData = cancelOrderCalculateData;

            _cancelOrderCalculate();
        };
    })(),
    cancelOrderCalculateInstant: (id, cancelOrderCalculateData) => {
        dispatch(actions.cancelOrderCalculate(id, cancelOrderCalculateData));
    },
    cancelOrderCalculateReset: () => {
        dispatch(actions.cancelOrderCalculateReset());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrderItemsWindow);
